export class GraphicData {
    constructor(
        public name: string,
        public valueOvercommision: number,
        public valueNumDoc: number
    ) { }
}

export class GraphicOvercommision {
    constructor (
      public name: string,
      public value: number) { }
}

export class GraphicNumDoc {
    constructor (
      public name: string,
      public value: number) { }
}
